// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"2aa36780","361":"69a0050f","673":"8e2b6397"}[chunkId] + ".chunk.js";
};